<template>
  <div id="debug">
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <div id="master-modal" class="modal" v-if="masterModalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>マスタ再読み込み</h2>
        </div>
        <div class="input-area">
          <ul>
            <li><label><input type="checkbox" @click="checkBoxAll" v-model="checkAll"> すべて選択</label></li>
            <li>
              <span class="label">企業コード：</span>
              <input @input="validateCorpId" v-model="corpIdValue" placeholder="企業ｺｰﾄﾞ指定の場合は入力">
            </li>
            <table>
              <tr>
                <td><li><label><input type="checkbox" id="m_accessory_category" value="accessoryCategoryMaster" v-model="checkedMasters">m_accessory_category</label></li></td>
                <td><li><label><input type="checkbox" id="m_auto_changer" value="autoChangerMaster" v-model="checkedMasters">m_auto_changer</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_bom_title" value="bomTitleMaster" v-model="checkedMasters">m_bom_title</label></li></td>
                <td><li><label><input type="checkbox" id="m_business" value="businessMaster" v-model="checkedMasters">m_business</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_category" value="categoryMaster" v-model="checkedMasters">m_category</label></li></td>
                <td><li><label><input type="checkbox" id="m_color" value="colorMaster" v-model="checkedMasters">m_color</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_color_comb" value="colorCombMaster" v-model="checkedMasters">m_color_comb</label></li></td>
                <td><li><label><input type="checkbox" id="m_color_material_table" value="colorMaterialTableMaster" v-model="checkedMasters">m_color_material_table</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_color_material_table_data" value="colorMaterialTableDataMaster" v-model="checkedMasters">m_color_material_table_data</label></li></td>
                <td><li><label><input type="checkbox" id="m_color_style" value="colorStyleMaster" v-model="checkedMasters">m_color_style</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_color_style_config" value="colorStyleConfigMaster" v-model="checkedMasters">m_color_style_config</label></li></td>
                <td><li><label><input type="checkbox" id="m_color_style_config_dtl" value="colorStyleConfigDtlMaster" v-model="checkedMasters">m_color_style_config_dtl</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_color_style_data" value="colorStyleDataMaster" v-model="checkedMasters">m_color_style_data</label></li></td>
                <td><li><label><input type="checkbox" id="m_comment" value="commentMaster" v-model="checkedMasters">m_comment</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_common_code" value="commonCodeMaster" v-model="checkedMasters">m_common_code</label></li></td>
                <td><li><label><input type="checkbox" id="m_contents" value="contentsMaster" v-model="checkedMasters">m_contents</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_core_pos" value="corePosMaster" v-model="checkedMasters">m_core_pos</label></li></td>
                <td><li><label><input type="checkbox" id="m_core_rule" value="coreRuleMaster" v-model="checkedMasters">m_core_rule</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_corp_client_person" value="corpClientPersonMaster" v-model="checkedMasters">m_corp_client_person</label></li></td>
                <td><li><label><input type="checkbox" id="m_delivery" value="deliveryMaster" v-model="checkedMasters">m_delivery</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_dim_config" value="dimConfigMaster" v-model="checkedMasters">m_dim_config</label></li></td>
                <td><li><label><input type="checkbox" id="m_dim_data" value="dimDataMaster" v-model="checkedMasters">m_dim_data</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_dxf" value="dxfMaster" v-model="checkedMasters">m_dxf</label></li></td>
                <td><li><label><input type="checkbox" id="m_estimate_config" value="estimateConfigMaster" v-model="checkedMasters">m_estimate_config</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_face_dxf" value="faceDxfMaster" v-model="checkedMasters">m_face_dxf</label></li></td>
                <td><li><label><input type="checkbox" id="m_fitting" value="fittingMaster" v-model="checkedMasters">m_fitting</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_fitting_extra" value="fittingExtraMaster" v-model="checkedMasters">m_fitting_extra</label></li></td>
                <td><li><label><input type="checkbox" id="m_fitting_process" value="fittingProcessMaster" v-model="checkedMasters">m_fitting_process</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_material" value="materialMaster" v-model="checkedMasters">m_material</label></li></td>
                <td><li><label><input type="checkbox" id="m_matrix" value="matrixMaster" v-model="checkedMasters">m_matrix</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_matrix_dtl" value="matrixDtlMaster" v-model="checkedMasters">m_matrix_dtl</label></li></td>
                <td><li><label><input type="checkbox" id="m_nesting_config" value="nestingConfigMaster" v-model="checkedMasters">m_nesting_config</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_option" value="optionMaster" v-model="checkedMasters">m_option</label></li></td>
                <td><li><label><input type="checkbox" id="m_option_item" value="optionItemMaster" v-model="checkedMasters">m_option_item</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_packing" value="packingMaster" v-model="checkedMasters">m_packing</label></li></td>
                <td><li><label><input type="checkbox" id="m_packing_no" value="packingNoMaster" v-model="checkedMasters">m_packing_no</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_param_rule" value="paramRuleMaster" v-model="checkedMasters">m_param_rule</label></li></td>
                <td><li><label><input type="checkbox" id="m_pcode" value="pcodeMaster" v-model="checkedMasters">m_pcode</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_pos_rule" value="posRuleMaster" v-model="checkedMasters">m_pos_rule</label></li></td>
                <td><li><label><input type="checkbox" id="m_price" value="priceMaster" v-model="checkedMasters">m_price</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_process" value="processMaster" v-model="checkedMasters">m_process</label></li></td>
                <td><li><label><input type="checkbox" id="m_process_info" value="processInfoMaster" v-model="checkedMasters">m_process_info</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_process_path" value="processPathMaster" v-model="checkedMasters">m_process_path</label></li></td>
                <td><li><label><input type="checkbox" id="m_series" value="seriesMaster" v-model="checkedMasters">m_series</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_sheet_data" value="sheetDataMaster" v-model="checkedMasters">m_sheet_data</label></li></td>
                <td><li><label><input type="checkbox" id="m_sheet_dim" value="sheetDimMaster" v-model="checkedMasters">m_sheet_dim</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_snap_rule" value="snapRuleMaster" v-model="checkedMasters">m_snap_rule</label></li></td>
                <td><li><label><input type="checkbox" id="m_system_config" value="systemConfigMaster" v-model="checkedMasters">m_system_config</label></li></td>
              </tr>
              <tr>
                <td><li><label><input type="checkbox" id="m_title_config" value="titleConfigMaster" v-model="checkedMasters">m_title_config</label></li></td>
                <td><li><label><input type="checkbox" id="m_category_tab" value="categoryTabMaster" v-model="checkedMasters">m_category_tab</label></li></td>
              </tr>
            </table>
          </ul>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="masterReLoad">マスタ読込</button>
          <button type="button" class="main_btn" @click="closeMasterModal">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="new-corp-modal" class="modal" v-if="newCorpModalShown"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>企業新規登録</h2>
        </div>
        <div class="input-area">
          <ul>
            <li>
              <span class="label">企業ID【任意】：</span>
              <input type="number" v-model.number="desiredCorpId" placeholder="企業ID">
              <div class="error_message">{{ validateCorpErrorMessages.desiredCorpId }}</div>
            </li>
            <li>
              <span class="label">企業名：</span>
              <input type="text" v-model="corpName" placeholder="企業名">
              <div class="error_message">{{ validateCorpErrorMessages.corpName }}</div>
            </li>
            <li>
              <span class="label">省略企業名：</span>
              <input type="text" v-model="corpNameShort" placeholder="省略企業名">
              <div class="error_message">{{ validateCorpErrorMessages.corpNameShort }}</div>
            </li>
            <li>
              <span class="label">郵便番号：</span>
              <input type="text" v-model="postcd" placeholder="郵便番号">
              <div class="error_message">{{ validateCorpErrorMessages.postcd }}</div>
            </li>
            <li>
              <span class="label">都道府県：</span>
              <input type="text" v-model="state" placeholder="都道府県">
              <div class="error_message">{{ validateCorpErrorMessages.state }}</div>
            </li>
            <li>
              <span class="label">市区町村：</span>
              <input type="text" v-model="city" placeholder="市区町村">
              <div class="error_message">{{ validateCorpErrorMessages.city }}</div>
            </li>
            <li>
              <span class="label">住所/番地：</span>
              <input type="text" v-model="street" placeholder="住所/番地">
              <div class="error_message">{{ validateCorpErrorMessages.street }}</div>
            </li>
            <li>
              <span class="label">電話番号：</span>
              <input type="text" v-model="tel" placeholder="電話番号">
              <div class="error_message">{{ validateCorpErrorMessages.tel }}</div>
            </li>
            <li>
              <span class="label">FAX番号：</span>
              <input type="text" v-model="fax" placeholder="FAX番号">
              <div class="error_message">{{ validateCorpErrorMessages.fax }}</div>
            </li>
            <li>
              <span class="label">管理者名：</span>
              <input type="text" v-model="adminLastName" placeholder="姓">
              <div class="error_message">{{ validateCorpErrorMessages.adminLastName }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="adminFirstName" placeholder="名">
              <div class="error_message">{{ validateCorpErrorMessages.adminFirstName }}</div>
            </li>
            <li>
              <span class="label">管理者名(カナ)：</span>
              <input type="text" v-model="adminLastNameKana" placeholder="姓(カナ)">
              <div class="error_message">{{ validateCorpErrorMessages.adminLastNameKana }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="adminFirstNameKana" placeholder="名(カナ)">
              <div class="error_message">{{ validateCorpErrorMessages.adminFirstNameKana }}</div>
            </li>
            <li>
              <span class="label">メールアドレス：</span>
              <input type="text" v-model="email" placeholder="メールアドレス">
              <div class="error_message">{{ validateCorpErrorMessages.email }}</div>
            </li>
            <li>
              <span class="label">ログインID：</span>
              <input type="text" v-model="loginId" placeholder="ログインID">
              <div class="error_message">{{ validateCorpErrorMessages.loginId }}</div>
            </li>
            <li>
              <span class="label">パスワード：</span>
              <input type="text" v-model="password" placeholder="パスワード">
              <div class="error_message">{{ validateCorpErrorMessages.password }}</div>
            </li>
          </ul>
          <div class="info_message">{{ corpErrorMessage.text }}</div>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="submitNewCorp">登録</button>
          <button type="button" class="main_btn" @click="closeNewCorpModal">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="new-trial-user" class="modal" v-if="newTrialUserShow"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>お試しユーザー本登録</h2>
        </div>
        <div class="input_area" ref="inputArea">
          <ul>
            <li>
              <span class="label">企業名：</span>
              <input type="text" v-model="trialForm.corpName" placeholder="企業名"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.corpName }}</div>
            </li>
            <li>
              <span class="label">省略企業名：</span>
              <input type="text" v-model="trialForm.corpNameShort" autocomplete="none" placeholder="省略企業名"/>
              <div class="valid_description">登録される企業名を16文字以内で設定してください。</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.corpNameShort }}</div>
            </li>
            <li>
              <span class="label">郵便番号：</span>
              <input type="text" v-model="trialForm.postcd" @keypress="validateNumber"
                @input="trialForm.postcd=inputRestNumber($event)" @blur="trialAddressCompletion"  maxlength="7" placeholder="郵便番号"/>
              <div class="valid_description">半角数値、ハイフン不要</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.postcd }}</div>
            </li>
            <li>
              <span class="label">都道府県：</span>
              <input type="text" v-model="trialForm.state" placeholder="都道府県"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.state }}</div>
            </li>
            <li>
              <span class="label">市区町村：</span>
              <input type="text" v-model="trialForm.city" placeholder="市区町村"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.city }}</div>
            </li>
            <li>
              <span class="label">その他住所/番地：</span>
              <input type="text" v-model="trialForm.street" placeholder="その他住所/番地"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.street }}</div>
            </li>
            <li>
              <span class="label">電話番号：</span>
              <input type="tel" v-model="trialForm.tel" @keypress="validateNumber" @input="trialForm.tel=inputRestNumber($event)" placeholder="電話番号"/>
              <div class="valid_description">半角数値、ハイフン不要</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.tel }}</div>
            </li>
            <li>
              <span class="label">登録者名：</span>
              <input type="text" v-model="trialForm.registrantLastName" placeholder="姓"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.registrantLastName }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="trialForm.registrantFirstName" placeholder="名"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.registrantFirstName }}</div>
            </li>
            <li>
              <span class="label">登録者名（カナ）：</span>
              <input type="text" v-model="trialForm.registrantLastNameKane" @keypress="validateKana"
                     @input="trialForm.registrantLastNameKane=inputRestKana($event)" placeholder="姓（カナ）"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.registrantLastNameKane }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="trialForm.registrantFirstNameKane" @keypress="validateKana"
                     @input="trialForm.registrantFirstNameKane=inputRestKana($event)" placeholder="名（カナ）"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.registrantFirstNameKane }}</div>
            </li>
            <li>
              <span class="label">メールアドレス/ログインID：</span>
              <input class="mail" type="text" v-model="trialForm.email" placeholder="メールアドレス/ログインID"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.email }}</div>
            </li>
            <li>
              <span class="label">パスワード：</span>
              <input type="password" v-model="trialForm.password" placeholder="パスワード"/>
              <div class="valid_description">半角英小文字、数字を含む8文字以上20文字以下のパスワードを設定してください。</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.password }}</div>
            </li>
            <li>
              <span class="label">パスワード(確認用)：</span>
              <input type="password" v-model="trialForm.confirmPassword" placeholder="パスワード(確認用)"/>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.confirmPassword }}</div>
              <div class="validate_error_messages">{{ validateTrialErrorMessages.CustomConstraint }}</div>
            </li>
          </ul>
          <div class="error_message">{{ trialErrorMessage.text }}</div>
        </div>

        <div class="button-area">
          <button type="button" class="main_btn" v-bind:class="{img_disable: isDisableSubmitTrial}" @click="submitRegisterTrialUser">登録</button>
          <button type="button" class="main_btn" @click="closeNewTrialUser">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="new-dc-user" class="modal" v-if="newDCUserShow"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>mmstyleユーザー本登録</h2>
        </div>
        <div class="input_area" ref="inputArea">
          <ul>
            <li>
              <span class="label">会社名：</span>
              <input type="text" v-model="dCUserForm.corpName" maxlength="32" placeholder="会社名"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.corpName }}</div>
            </li>
            <li>
              <span class="label">支店名・営業所名：</span>
              <input type="text" v-model="dCUserForm.corpBranchName" maxlength="32" placeholder="支店名・営業所名"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.corpBranchName }}</div>
            </li>
            <li>
              <span class="label">メールアドレス：</span>
              <input class="mail" type="text" v-model="dCUserForm.email" maxlength="128" placeholder="メールアドレス"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.email }}</div>
            </li>
            <li>
              <span class="label">電話番号：</span>
              <input type="tel" v-model="dCUserForm.tel" @keypress="validateNumber"
                @input="dCUserForm.tel=inputRestNumber($event)" maxlength="16" placeholder="電話番号"/>
              <div class="valid_description">半角数値、ハイフン不要</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.tel }}</div>
            </li>
            <li>
              <span class="label">FAX：</span>
              <input type="tel" v-model="dCUserForm.fax" @keypress="validateNumber"
                @input="dCUserForm.fax=inputRestNumber($event)" maxlength="16" placeholder="FAX"/>
              <div class="valid_description">半角数値、ハイフン不要</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.fax }}</div>
            </li>
            <li>
              <span class="label">郵便番号：</span>
              <input type="text" v-model="dCUserForm.postcd" @keypress="validateNumber"
                @input="dCUserForm.postcd=inputRestNumber($event)" @blur="dCUserAddressCompletion"  maxlength="7" placeholder="郵便番号"/>
              <div class="valid_description">半角数値、ハイフン不要</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.postcd }}</div>
            </li>
            <li>
              <span class="label">住所：</span>
              <input type="text" v-model="dCUserForm.state" maxlength="32" placeholder="都道府県"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.state }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="dCUserForm.city" maxlength="32" placeholder="市区町村"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.city }}</div>
            </li>
            <li>
              <span class="label">以下住所：</span>
              <input type="text" v-model="dCUserForm.street" maxlength="32"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.street }}</div>
            </li>
            <li>
              <span class="label">招待コード：</span>
              <input type="text" v-model="dCUserForm.inviteCode" maxlength="16" placeholder="招待コード"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.inviteCode }}</div>
            </li>
            <li>
              <span class="label">業種：</span>
              <select class="list_box" v-model.number="dCUserForm.corpType">
                <option value='' class="select_placeholder">選択してください</option>
                <option v-for="(type,index) in corpTypeList" :key="'corptype-' + index" v-bind:value="type.code">{{type.label}}</option>
              </select>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.corpType }}</div>
            </li>
            <li>
              <span class="label">所属部署：</span>
              <input type="text" v-model="dCUserForm.corpDept" maxlength="32" placeholder="所属部署"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.corpDept }}</div>
            </li>
            <li>
              <span class="label">氏名：</span>
              <input type="text" v-model="dCUserForm.userLastName" maxlength="32" placeholder="家具"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.userLastName }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="dCUserForm.userFirstName" maxlength="32" placeholder="太郎"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.userFirstName }}</div>
            </li>
            <li>
              <span class="label">氏名（カナ）：</span>
              <input type="text" v-model="dCUserForm.userLastNameKana" @keypress="validateKana"
                @input="dCUserForm.userLastNameKana=inputRestKana($event)" maxlength="32" placeholder="カグ"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.userLastNameKana }}</div>
            </li>
            <li>
              <span class="label"></span>
              <input type="text" v-model="dCUserForm.userFirstNameKana" @keypress="validateKana"
                @input="dCUserForm.userFirstNameKana=inputRestKana($event)" maxlength="32" placeholder="タロウ"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.userFirstNameKana }}</div>
            </li>
            <li>
              <span class="label">パスワード：</span>
              <input type="password" v-model="dCUserForm.password" maxlength="20" placeholder="パスワード"/>
              <div class="valid_description">半角英小文字、数字を含む8文字以上20文字以下のパスワードを設定してください。</div>
            </li>
            <li>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.password }}</div>
            </li>
            <li>
              <span class="label">パスワード(確認用)：</span>
              <input type="password" v-model="dCUserForm.confirmPassword" maxlength="20" placeholder="パスワード(確認用)"/>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.confirmPassword }}</div>
              <div class="validate_error_messages">{{ validateDCUserErrorMessages.CustomConstraint }}</div>
            </li>
            <li>
              <span class="label">メールマガジンを受け取る：</span>
              <input type="checkbox" v-model="dCUserForm.recvInfo">
            </li>
          </ul>
          <div class="error_message">{{ DCUserErrorMessage.text }}</div>
        </div>

        <div class="button-area">
          <button type="button" class="main_btn" v-bind:class="{img_disable: isDisableSubmitTrial}" @click="submitRegisterDCUser">登録</button>
          <button type="button" class="main_btn" @click="closeNewDCUser">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="new-ftp-modal" class="modal" v-if="newFtpModalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-ftp">
        <div class="title-area" id="modal-moving">
          <h2>FTP登録</h2>
        </div>
        <div class="input-area" ref="inputArea">
          <ul>
            <div class="headline">FTPサーバー基本情報</div>
            <li>
              <span class="label">DNSホスト名(IPアドレスでも可)：</span>
              <input type="text" v-model="newFtpForm.newFtpDnsHost" placeholder="DNSホスト名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.ftpDnsHost }}</div>
            </li>
            <li>
              <span class="label">ポート番号：</span>
              <input type="number" v-model="newFtpForm.newFtpPortNumber" placeholder="ポート番号">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.ftpPortNumber }}</div>
            </li>
            <li>
              <span class="label">FTP接続ユーザー名：</span>
              <input type="text" v-model="newFtpForm.newFtpConnectUser" placeholder="FTP接続ユーザー名：">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.ftpConnectUser }}</div>
            </li>
            <li>
              <span class="label">FTP接続パスワード：</span>
              <input type="password" v-model="newFtpForm.newFtpConnectPassword" placeholder="FTP接続パスワード">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.ftpConnectPassword }}</div>
            </li>
            <li>
              <span class="label">FTP接続パスワード(確認用)：</span>
              <input type="password" v-model="newFtpForm.confirmPassword" placeholder="パスワード(確認用)">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.confirmPassword }}</div>
            </li><br>
            <div class="headline">転送先ディレクトリ名</div>
            <li>
              <span class="label">共通出力先：</span>
              <input class="common" type="text" v-model="newFtpForm.directoryPathOfCommon" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfCommon }}</div>
            </li>
            <div class="kobetu">以下の図面で個別設定されていない図面は共通出力先に転送いたします</div>
            <li>
              <span class="label">意匠図：</span>
              <input id="plan" type="text" v-model="newFtpForm.directoryPathOfPlan" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfPlan }}</div>
            </li>
            <li>
              <span class="label">見積書：</span>
              <input id="estimate" type="text" v-model="newFtpForm.directoryPathOfEstimate" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfEstimate }}</div>
            </li>
            <li>
              <span class="label">フォトリアルCG：</span>
              <input id="cg" type="text" v-model="newFtpForm.directoryPathOfCg" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfCg }}</div>
            </li>
            <li>
              <span class="label">プレゼンシート：</span>
              <input id="presentation" type="text" v-model="newFtpForm.directoryPathOfPresentation" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfPresentation }}</div>
            </li>
            <li>
              <span class="label">コンバイン図：</span>
              <input id="combine" type="text" v-model="newFtpForm.directoryPathOfCombine" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfCombine }}</div>
            </li>
            <li>
              <span class="label">ユニット図：</span>
              <input id="unit" type="text" v-model="newFtpForm.directoryPathOfUnit" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfUnit }}</div>
            </li>
            <li>
              <span class="label">加工図：</span>
              <input id="process" type="text" v-model="newFtpForm.directoryPathOfProcess" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfProcess }}</div>
            </li>
            <li>
              <span class="label">木取図(パネルソー)：</span>
              <input id="nestingPanel" type="text" v-model="newFtpForm.directoryPathOfNestingPanel" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfNestingPanel }}</div>
            </li>
            <li>
              <span class="label">木取図(ランニングソー)：</span>
              <input id="nestingRunning" type="text" v-model="newFtpForm.directoryPathOfNestingRunning" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfNestingRunning }}</div>
            </li>
            <li>
              <span class="label">設計BOM/資材一覧表：</span>
              <input id="eBom" type="text" v-model="newFtpForm.directoryPathOfEBom" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfEBom }}</div>
            </li>
            <li>
              <span class="label">NC DATA：</span>
              <input id="ncData" type="text" v-model="newFtpForm.directoryPathOfNcData" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfNcData }}</div>
            </li>
            <li>
              <span class="label">MasterBom：</span>
              <input id="masterBom" type="text" v-model="newFtpForm.directoryPathOfMasterBom" placeholder="転送先ディレクトリ名">
              <div class="validate_error_messages">{{ validateFtpErrorMessages.directoryPathOfMasterBom }}</div>
            </li>
          </ul>
          <div class="error_message">{{ ftpErrorMessage.text }}</div>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" @click="submitNewFtp">登録</button>
          <button type="button" class="main_btn" @click="closeNewFtpModal">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="trial-main-url-modal" class="modal" v-if="newTrialMainUrl" v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main trial-main-url-modal" >
        <div class="title-area" id="modal-moving">
          <h2>お試しユーザー本登録URL発行</h2>
        </div>
        <div class="input-area">
          <div class="error_message">{{ newTrialMainErrorMessage.text }}</div>
          <ul>
            <li>
              <span class="label">メールアドレス/ログインID：</span>
              <input type="text" v-model="newTrialMainUrlForm.email" placeholder="メールアドレス/ログインID">
              <div class="error_message">{{ validateNewTrialMainMessages.email }}</div>
            </li>
          </ul>
        </div>
        <div class="button-area">
          <button type="button" class="main_btn" v-bind:class="{img_disable: isDisabledCreateTrialMainUrl}" @click="submitCreateTrialMainUrl">登録</button>
          <button type="button" class="main_btn" @click="closeTrialMainUrl">キャンセル</button>
        </div>
      </div>
    </div>

    <div id="space-data-csv-upload">
      <h4>空間データCSVアップロード</h4>
      <div>
        <ul class="select_list">
          <li
            class="radio"
            v-for="(objectType, idx) in uploadFileObjectTypeList"
            :key="objectType.code"
          >
            <input type="radio" :id="'debug_upload_' + idx" :value="objectType" v-model="uploadFileObjectType">
            <label :for="'debug_upload_' + idx">{{ objectType.label }}</label>
          </li>
        </ul>
        <input ref="fileInput" type="file" multiple="multiple" accept=".csv" @change="onUploadFileChange" />
        <button @click="uploadSpaceDataCsv" type="button" class="main_btn">アップロード</button>
        <div class="info_message" v-if="message">{{ message }}</div>
        <div class="error_message" v-if="fieldErrorMessages.required">{{ fieldErrorMessages.required }}</div>
        <div class="error_message" v-if="fieldErrorMessages.valid">{{ fieldErrorMessages.valid }}</div>
      </div>
      <h4>テスト用API</h4>
      <div>
        <span v-for="n in 5" :key="n">
          <button type="button" class="main_btn" @click="doDebug(n)">test{{ n }}</button>
        </span>
        <input v-model="debugParam1">
      </div>
      <h4>登録</h4>
      <div>
        <button type="button" class="main_btn" @click="showNewCorpModal">企業新規登録</button>
        <button type="button" class="main_btn" @click="showNewTrialUser">お試し本登録</button>
        <button type="button" class="main_btn" @click="showNewDCUser">mmstyle本登録</button>
        <button type="button" class="main_btn" @click="showTrialMainUrl">本登録URL発行</button>
        <button type="button" class="main_btn" @click="showMasterModal">マスタ再読込</button>
        <button type="button" class="main_btn" v-if="isUseOrder" @click="showOrderList" id="order_btn">受注リスト</button>
        <button type="button" class="main_btn" @click="showContentsData">コンテンツ登録</button>
        <button v-if="isUseFtp" type="button" class="main_btn" @click="showNewFtpModal">FTP登録</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {OBJECT_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import LoadingModal from '../../../components/common/LoadingModal'
import {CORP_TYPE} from '../../../payment/constants/TypeEc'

export default {
  name: 'Debug',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      // *****************************************************************
      // 空間データCSVアップロード
      // *****************************************************************
      uploadFiles: [],
      /** アップロードファイルタイプ */
      uploadFileObjectType: OBJECT_TYPE.UNIT,
      uploadFileObjectTypeList: [ OBJECT_TYPE.UNIT, OBJECT_TYPE.COMBINE, OBJECT_TYPE.SETPLAN, OBJECT_TYPE.ACCESSORY, OBJECT_TYPE.DELETE, OBJECT_TYPE.SUGATSUNE ],
      message: '',
      errorMessage: { text: '' },
      fieldErrorMessages: {
        required: '',
        valid: ''
      },
      // *****************************************************************
      // マスタ再読み込み
      // *****************************************************************
      checkAll: '',
      masterModalShown: false,
      checkedMasters: [],
      corpIdValue: '',
      // *****************************************************************
      // 企業新規登録
      // *****************************************************************
      newCorpModalShown: false,
      desiredCorpId: '',
      corpName: '',
      corpNameShort: '',
      postcd: '',
      state: '',
      city: '',
      street: '',
      tel: '',
      fax: '',
      adminLastName: '',
      adminFirstName: '',
      adminLastNameKana: '',
      adminFirstNameKana: '',
      email: '',
      loginId: '',
      password: '',
      /** 共通エラーメッセージ */
      corpErrorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateCorpErrorMessages: {
        desiredCorpId: '',
        corpName: '',
        corpNameShort: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        tel: '',
        fax: '',
        adminLastName: '',
        adminFirstName: '',
        adminLastNameKana: '',
        adminFirstNameKana: '',
        email: '',
        loginId: '',
        password: ''
      },
      // *****************************************************************
      // お試しユーザー登録
      // *****************************************************************
      newTrialUserShow: false,
      trialForm: {
        corpName: '',
        corpNameShort: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        tel: '',
        registrantLastName: '',
        registrantFirstName: '',
        registrantLastNameKane: '',
        registrantFirstNameKane: '',
        email: '',
        password: '',
        confirmPassword: ''
      },
      /** 共通エラーメッセージ */
      trialErrorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateTrialErrorMessages: {
        corpName: '',
        corpNameShort: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        tel: '',
        registrantLastName: '',
        registrantFirstName: '',
        registrantLastNameKane: '',
        registrantFirstNameKane: '',
        email: '',
        password: '',
        confirmPassword: '',
        CustomConstraint: ''
      },
      isDisableSubmitTrial: false,
      // *****************************************************************
      // mmstyleユーザー登録
      // *****************************************************************
      newDCUserShow: false,
      dCUserForm: {
        corpType: '',
        corpName: '',
        corpBranchName: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        recvInfo: '',
        password: '',
        confirmPassword: ''
      },
      /** 共通エラーメッセージ */
      DCUserErrorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateDCUserErrorMessages: {
        corpType: '',
        corpName: '',
        corpBranchName: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        recvInfo: '',
        password: '',
        confirmPassword: ''
      },
      isDisableSubmitDCUser: false,
      // *****************************************************************
      // お試しﾕｰｻﾞｰ本登録URL発行
      // *****************************************************************
      newTrialMainUrl: false,
      newTrialMainUrlForm: {
        email: ''
      },
      newTrialMainErrorMessage: { text: '' },
      validateNewTrialMainMessages: { email: '' },
      isDisabledCreateTrialMainUrl: false,
      // *****************************************************************
      // テスト用API
      // *****************************************************************
      debugParam1: false,
      // *****************************************************************
      // FTP登録
      // *****************************************************************
      newFtpModalShown: false,
      newFtpForm: {
        newFtpDnsHost: '',
        newFtpPortNumber: '',
        newFtpConnectUser: '',
        newFtpConnectPassword: '',
        confirmPassword: '',
        directoryPathOfCommon: '',
        directoryPathOfPlan: '',
        directoryPathOfEstimate: '',
        directoryPathOfCg: '',
        directoryPathOfPresentation: '',
        directoryPathOfCombine: '',
        directoryPathOfUnit: '',
        directoryPathOfProcess: '',
        directoryPathOfNestingPanel: '',
        directoryPathOfNestingRunning: '',
        directoryPathOfEBom: '',
        directoryPathOfNcData: '',
        directoryPathOfMasterBom: ''
      },
      ftpInfo: {},
      /** 共通エラーメッセージ */
      ftpErrorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateFtpErrorMessages: {
        ftpDnsHost: '',
        ftpPortNumber: '',
        ftpConnectUser: '',
        ftpConnectPassword: '',
        confirmPassword: '',
        directoryPathOfCommon: '',
        directoryPathOfPlan: '',
        directoryPathOfEstimate: '',
        directoryPathOfCg: '',
        directoryPathOfPresentation: '',
        directoryPathOfCombine: '',
        directoryPathOfUnit: '',
        directoryPathOfProcess: '',
        directoryPathOfNestingPanel: '',
        directoryPathOfNestingRunning: '',
        directoryPathOfEBom: '',
        directoryPathOfNcData: '',
        directoryPathOfMasterBom: ''
      }
    }
  },
  computed: {
    isUseOrder: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.debugOrder
    },
    corpTypeList: function () {
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
    },
    /** FTP転送ライセンスフラグ */
    isUseFtp: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.sendFtp
    }
  },
  methods: {
    // *****************************************************************
    // 空間データCSVアップロード
    // *****************************************************************
    onUploadFileChange: function (event) {
      event.preventDefault()
      this.clearMessages()
      this.uploadFiles = event.target.files
    },
    uploadSpaceDataCsv: function (event) {
      event.preventDefault()
      this.clearMessages()

      // 送信データ
      let payload = new FormData()
      for (let i = 0; i < this.uploadFiles.length; i++) {
        payload.append('files', new Blob([this.uploadFiles[i]], {type: 'application/csv'}), this.uploadFiles[i].name)
      }
      payload.append('objectType', this.uploadFileObjectType.code)
      axios.post(API_URL.UPLOAD + '/csv/space-data', payload
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: '空間編集エラー',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error',
            textAlign: 'left',
            onOk: this.getEditingFileData
          }
          App.showModal(modalData)
        } else {
          this.message = response.data.infoMessage
          // this.clearFiles()
          this.$emit('fileUploadCallback')
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    clearFiles: function () {
      this.$refs.fileInput.value = ''
      this.uploadFiles = []
    },
    clearMessages: function () {
      this.message = ''
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        required: '',
        valid: ''
      }
    },
    // *****************************************************************
    // テスト用API
    // *****************************************************************
    doDebug: function (param) {
      let payload = {debugParam1: this.debugParam1}
      axios.post(API_URL.ADMIN + '/debug/' + param, payload
      ).then(response => {

      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    // *****************************************************************
    // マスタ再読み込み
    // *****************************************************************
    showMasterModal: function () {
      this.checkedMasters = []
      this.checkAll = ''
      this.corpIdValue = ''
      this.masterModalShown = true
      this.$emit('onShowModal')
    },
    showOrderList: function () {
      this.$router.push({
        name: 'Order',
        params: { pageNo: 1, dataCount: 16 }
      })
    },
    checkBoxAll: function () {
      this.checkAll = !this.checkAll
      this.checkedMasters = []
      if (this.checkAll) {
        this.checkedMasters.push('accessoryCategoryMaster')
        this.checkedMasters.push('autoChangerMaster')
        this.checkedMasters.push('bomTitleMaster')
        this.checkedMasters.push('businessMaster')
        this.checkedMasters.push('categoryMaster')
        this.checkedMasters.push('colorMaster')
        this.checkedMasters.push('colorCombMaster')
        this.checkedMasters.push('colorMaterialTableMaster')
        this.checkedMasters.push('colorMaterialTableDataMaster')
        this.checkedMasters.push('colorStyleMaster')
        this.checkedMasters.push('colorStyleConfigMaster')
        this.checkedMasters.push('colorStyleConfigDtlMaster')
        this.checkedMasters.push('colorStyleDataMaster')
        this.checkedMasters.push('commentMaster')
        this.checkedMasters.push('commonCodeMaster')
        this.checkedMasters.push('contentsMaster')
        this.checkedMasters.push('coreRuleMaster')
        this.checkedMasters.push('corePosMaster')
        this.checkedMasters.push('corpClientPersonMaster')
        this.checkedMasters.push('deliveryMaster')
        this.checkedMasters.push('dimConfigMaster')
        this.checkedMasters.push('dimDataMaster')
        this.checkedMasters.push('dxfMaster')
        this.checkedMasters.push('estimateConfigMaster')
        this.checkedMasters.push('faceDxfMaster')
        this.checkedMasters.push('fittingMaster')
        this.checkedMasters.push('fittingExtraMaster')
        this.checkedMasters.push('fittingProcessMaster')
        this.checkedMasters.push('materialMaster')
        this.checkedMasters.push('matrixMaster')
        this.checkedMasters.push('matrixDtlMaster')
        this.checkedMasters.push('nestingConfigMaster')
        this.checkedMasters.push('optionMaster')
        this.checkedMasters.push('optionItemMaster')
        this.checkedMasters.push('packingMaster')
        this.checkedMasters.push('paramRuleMaster')
        this.checkedMasters.push('pcodeMaster')
        this.checkedMasters.push('posRuleMaster')
        this.checkedMasters.push('priceMaster')
        this.checkedMasters.push('processMaster')
        this.checkedMasters.push('processInfoMaster')
        this.checkedMasters.push('processPathMaster')
        this.checkedMasters.push('seriesMaster')
        this.checkedMasters.push('sheetDataMaster')
        this.checkedMasters.push('sheetDimMaster')
        this.checkedMasters.push('snapRuleMaster')
        this.checkedMasters.push('systemConfigMaster')
        this.checkedMasters.push('titleConfigMaster')
        this.checkedMasters.push('packingMaster')
        this.checkedMasters.push('packingNoMaster')
      }
    },
    masterReLoad: function () {
      let payload = {
        checkedMasters: this.checkedMasters,
        corpId: this.corpIdValue
      }
      axios.post(API_URL.MASTER + '/reLoad', payload
      ).then(response => {
        App.showModal({
          messages: ['更新しました。']
        })
        this.masterModalShown = false
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateCorpErrorMessages)
      })
    },
    closeMasterModal: function () {
      this.masterModalShown = false
      this.checkedMasters = []
      this.checkAll = ''
      this.$emit('onCloseModal')
    },
    // *****************************************************************
    // 企業新規登録
    // *****************************************************************
    showNewCorpModal: function () {
      this.desiredCorpId = ''
      this.corpName = ''
      this.corpNameShort = ''
      this.postcd = ''
      this.state = ''
      this.city = ''
      this.street = ''
      this.tel = ''
      this.fax = ''
      this.adminLastName = ''
      this.adminFirstName = ''
      this.adminLastNameKana = ''
      this.adminFirstNameKana = ''
      this.adminName = ''
      this.email = ''
      this.loginId = ''
      this.password = ''
      this.newCorpModalShown = true
      this.$emit('onShowModal')
    },
    closeNewCorpModal: function () {
      this.corpErrorMessage = { text: '' }
      for (let key in this.validateCorpErrorMessages) {
        this.validateCorpErrorMessages[key] = ''
      }
      this.newCorpModalShown = false
      this.$emit('onCloseModal')
    },
    submitNewCorp: function () {
      this.corpErrorMessage = { text: '' }
      for (let key in this.validateCorpErrorMessages) {
        this.validateCorpErrorMessages[key] = ''
      }
      let payload = {
        desiredCorpId: this.desiredCorpId,
        corpName: this.corpName,
        corpNameShort: this.corpNameShort,
        postcd: this.postcd,
        state: this.state,
        city: this.city,
        street: this.street,
        tel: this.tel,
        fax: this.fax,
        adminLastName: this.adminLastName,
        adminFirstName: this.adminFirstName,
        adminLastNameKana: this.adminLastNameKana,
        adminFirstNameKana: this.adminFirstNameKana,
        email: this.email,
        loginId: this.loginId,
        password: this.password
      }
      axios.post(API_URL.ADMIN + '/new-corp', payload
      ).then(response => {
        App.showModal({
          messages: ['登録しました。']
        })
        this.newCorpModalShown = false
      }).catch(error => {
        Api.handleError(error, this.corpErrorMessage, this.validateCorpErrorMessages)
      })
    },
    // *****************************************************************
    // お試しユーザー登録
    // *****************************************************************
    showNewTrialUser: function () {
      this.$emit('onShowModal')
      this.newTrialUserShow = true
    },
    closeNewTrialUser: function () {
      this.$emit('onCloseModal')
      this.newTrialUserShow = false
    },
    submitRegisterTrialUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.isDisableSubmitTrial = true
      this.trialErrorMessage = { text: '' }
      for (let key in this.validateTrialErrorMessages) {
        this.validateTrialErrorMessages[key] = ''
      }

      let payload = {
        corpName: this.trialForm.corpName,
        corpNameShort: this.trialForm.corpNameShort,
        postcd: this.trialForm.postcd,
        state: this.trialForm.state,
        city: this.trialForm.city,
        street: this.trialForm.street,
        tel: this.trialForm.tel,
        registrantLastName: this.trialForm.registrantLastName,
        registrantFirstName: this.trialForm.registrantFirstName,
        registrantLastNameKane: this.trialForm.registrantLastNameKane,
        registrantFirstNameKane: this.trialForm.registrantFirstNameKane,
        email: this.trialForm.email,
        loginId: this.trialForm.email,
        password: this.trialForm.password,
        confirmPassword: this.trialForm.confirmPassword,
        // バリデーションエラーにかかるので適当な値を設定
        opQnMarketTypes: [0],
        opQnMarketDetail: 'sample',
        opQnProductsTypes: [0],
        opQnProductsDetail: 'sample',
        opQnStandardProductRate: '1',
        opQnBespokeCustomRate: '1',
        opQnDarosInterestTypes: [0],
        opQnDarosInterestDetail: 'sample',
        opQnOrderPlaceTypes: [0],
        opQnOrderPlaceDetail: 'sample',
        opQnProductionUnit: '0',
        opQnProductionNum: 'sample',
        opQnIndirectPersonnelNum: '0',
        isDebug: true
      }
      axios.post(API_URL.ADMIN + '/debug/complete-trial-user', payload
      ).then(response => {
        App.showModal({
          messages: ['お試しユーザーの登録が完了しました。']
        })
        this.newTrialUserShow = false
      }).catch(error => {
        Api.handleError(error, this.trialErrorMessage, this.validateTrialErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
        this.isDisableSubmitTrial = false
      })
    },
    validateKana: function (event) {
      if (!Check.isKana(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestKana: function (event) {
      // テキスト補正
      let str = FormUtil.restKana(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    trialAddressCompletion: function () {
      FormUtil.addressCompletion(this.trialForm.postcd, (address) => {
        this.$set(this.trialForm, 'state', address.state)
        this.$set(this.trialForm, 'city', address.city)
        this.$set(this.trialForm, 'street', address.street)
      })
    },
    // *****************************************************************
    // mmstyleユーザー登録
    // *****************************************************************
    showNewDCUser: function () {
      this.$emit('onShowModal')
      this.newDCUserShow = true
    },
    closeNewDCUser: function () {
      this.$emit('onCloseModal')
      this.newDCUserShow = false
    },
    submitRegisterDCUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.isDisableSubmitDCUser = true
      this.DCUserErrorMessage = { text: '' }
      for (let key in this.validateDCUserErrorMessages) {
        this.validateDCUserErrorMessages[key] = ''
      }

      let payload = {
        corpType: this.dCUserForm.corpType,
        corpName: this.dCUserForm.corpName,
        corpBranchName: this.dCUserForm.corpBranchName,
        corpDept: this.dCUserForm.corpDept,
        userLastName: this.dCUserForm.userLastName,
        userFirstName: this.dCUserForm.userFirstName,
        userLastNameKana: this.dCUserForm.userLastNameKana,
        userFirstNameKana: this.dCUserForm.userFirstNameKana,
        email: this.dCUserForm.email,
        tel: this.dCUserForm.tel,
        fax: this.dCUserForm.fax,
        postcd: this.dCUserForm.postcd,
        state: this.dCUserForm.state,
        city: this.dCUserForm.city,
        street: this.dCUserForm.street,
        // infosrc: this.dCUserForm.infosrc,
        inviteCode: this.dCUserForm.inviteCode,
        // requestPayment: this.dCUserForm.requestPayment,
        recvInfo: this.dCUserForm.recvInfo,
        password: this.dCUserForm.password,
        confirmPassword: this.dCUserForm.confirmPassword
      }
      axios.post(API_URL.ADMIN + '/debug/complete-dc-user', payload
      ).then(response => {
        App.showModal({
          messages: ['mmstyleユーザーの登録が完了しました。']
        })
        this.newDCUserShow = false
      }).catch(error => {
        Api.handleError(error, this.DCUserErrorMessage, this.validateDCUserErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
        this.isDisableSubmitDCUser = false
      })
    },
    dCUserAddressCompletion: function () {
      FormUtil.addressCompletion(this.dCUserForm.postcd, (address) => {
        this.$set(this.dCUserForm, 'state', address.state)
        this.$set(this.dCUserForm, 'city', address.city)
        this.$set(this.dCUserForm, 'street', address.street)
      })
    },
    // *****************************************************************
    // お試しユーザー登録/mmstyleユーザー登録の共通処理
    // *****************************************************************
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    // *****************************************************************
    // お試しﾕｰｻﾞｰ本登録URL発行
    // *****************************************************************
    showTrialMainUrl: function () {
      this.$emit('onShowModal')
      this.newTrialMainUrl = true
    },
    closeTrialMainUrl: function () {
      this.$emit('onCloseModal')
      this.newTrialMainUrlForm.email = ''
      this.newTrialMainErrorMessage.text = ''
      this.validateNewTrialMainMessages.email = ''
      this.newTrialMainUrl = false
    },
    submitCreateTrialMainUrl: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.isDisabledCreateTrialMainUrl = true
      this.newTrialMainErrorMessage.text = ''
      this.validateNewTrialMainMessages.email = ''
      let payload = {
        email: this.newTrialMainUrlForm.email
      }
      axios.post(API_URL.ADMIN + '/new-trial-main-url', payload
      ).then(response => {
        App.showModal({
          messages: ['お試しユーザーの本登録URLの発行が完了しました。\n\n', response.data.data],
          onOk: this.closeTrialMainUrl
        })
      }).catch(error => {
        Api.handleError(error, this.newTrialMainErrorMessage, this.validateNewTrialMainMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
        this.isDisabledCreateTrialMainUrl = false
      })
    },
    // *****************************************************************
    // マスタ再読み込み
    // *****************************************************************
    validateCorpId: function () {
      this.corpIdValue = this.corpIdValue.replace(/\D/g, '')
    },
    // *****************************************************************
    // コンテンツ登録
    // *****************************************************************
    showContentsData: function () {
      let routeData = this.$router.resolve({name: 'ContentsData'})
      window.open(routeData.href, '_blank')
    },
    // *****************************************************************
    // FTP登録
    // *****************************************************************
    showNewFtpModal: function () {
      this.$emit('onShowModal')
      this.newFtpModalShown = true
    },
    closeNewFtpModal: function () {
      this.ftpErrorMessage = { text: '' }
      for (let key in this.validateFtpErrorMessages) {
        this.validateFtpErrorMessages[key] = ''
      }
      this.$emit('onCloseModal')
      this.newFtpModalShown = false
    },
    submitNewFtp: function () {
      this.ftpErrorMessage = { text: '' }
      for (let key in this.validateFtpErrorMessages) {
        this.validateFtpErrorMessages[key] = ''
      }
      let payload = {
        ftpDnsHost: this.newFtpForm.newFtpDnsHost,
        ftpPortNumber: this.newFtpForm.newFtpPortNumber,
        ftpConnectUser: this.newFtpForm.newFtpConnectUser,
        ftpConnectPassword: this.newFtpForm.newFtpConnectPassword,
        confirmPassword: this.newFtpForm.confirmPassword,
        directoryPathOfCommon: this.newFtpForm.directoryPathOfCommon,
        directoryPathOfPlan: this.newFtpForm.directoryPathOfPlan,
        directoryPathOfEstimate: this.newFtpForm.directoryPathOfEstimate,
        directoryPathOfCg: this.newFtpForm.directoryPathOfCg,
        directoryPathOfPresentation: this.newFtpForm.directoryPathOfPresentation,
        directoryPathOfCombine: this.newFtpForm.directoryPathOfCombine,
        directoryPathOfUnit: this.newFtpForm.directoryPathOfUnit,
        directoryPathOfProcess: this.newFtpForm.directoryPathOfProcess,
        directoryPathOfNestingPanel: this.newFtpForm.directoryPathOfNestingPanel,
        directoryPathOfNestingRunning: this.newFtpForm.directoryPathOfNestingRunning,
        directoryPathOfEBom: this.newFtpForm.directoryPathOfEBom,
        directoryPathOfNcData: this.newFtpForm.directoryPathOfNcData,
        directoryPathOfMasterBom: this.newFtpForm.directoryPathOfMasterBom
      }
      axios.post(API_URL.ADMIN + '/debug/new-ftp', payload
      ).then(response => {
        App.showModal({
          messages: ['登録しました。']
        })
        this.newFtpModalShown = false
      }).catch(error => {
        Api.handleError(error, this.ftpErrorMessage, this.validateFtpErrorMessages)
      })
    },
    getFtp: function () {
      axios.get(API_URL.ADMIN + '/debug/get-ftp-conf'
      ).then(response => {
        this.ftpInfo = response.data.data
        this.newFtpForm.newFtpDnsHost = this.ftpInfo.ftpDnsHost
        this.newFtpForm.newFtpPortNumber = this.ftpInfo.ftpPortNumber
        this.newFtpForm.newFtpConnectUser = this.ftpInfo.ftpConnectUser
        this.newFtpForm.newFtpConnectPassword = ''
        this.newFtpForm.confirmPassword = ''
        this.newFtpForm.directoryPathOfCommon = this.ftpInfo.directoryPathOfCommon
        this.newFtpForm.directoryPathOfPlan = this.ftpInfo.directoryPathOfPlan
        this.newFtpForm.directoryPathOfEstimate = this.ftpInfo.directoryPathOfEstimate
        this.newFtpForm.directoryPathOfCg = this.ftpInfo.directoryPathOfCg
        this.newFtpForm.directoryPathOfPresentation = this.ftpInfo.directoryPathOfPresentation
        this.newFtpForm.directoryPathOfCombine = this.ftpInfo.directoryPathOfCombine
        this.newFtpForm.directoryPathOfUnit = this.ftpInfo.directoryPathOfUnit
        this.newFtpForm.directoryPathOfProcess = this.ftpInfo.directoryPathOfProcess
        this.newFtpForm.directoryPathOfNestingPanel = this.ftpInfo.directoryPathOfNestingPanel
        this.newFtpForm.directoryPathOfNestingRunning = this.ftpInfo.directoryPathOfNestingRunning
        this.newFtpForm.directoryPathOfEBom = this.ftpInfo.directoryPathOfEBom
        this.newFtpForm.directoryPathOfNcData = this.ftpInfo.directoryPathOfNcData
        this.newFtpForm.directoryPathOfMasterBom = this.ftpInfo.directoryPathOfMasterBom
      }).catch(error => {
        Api.handleError(error)
      })
    }
  },
  created: function () {
    this.getFtp()
  }
}
</script>
<style src="../../../css/planning/side_tab_nav.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
h4+div {
  margin-bottom: 10px;
}
input[type=file] {
  cursor: pointer;
}
button {
  width: 110px;
  margin-bottom: 5px;
}
#master-modal {
  font-size: 15px;
  font-weight: normal;
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 120px;
    font-weight: normal;
  }
  .error_message {
    margin-left: 130px;
  }
}
#new-corp-modal {
  font-size: 15px;
  font-weight: normal;
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 120px;
    font-weight: normal;
  }
  .error_message {
    margin-left: 130px;
  }
  .info_message{
    color: #dc3545;
    margin-top: 10px;
    margin-left: 10px;
  }
}
#space-data-csv-upload {
  input {
    max-width: calc(100% - 26px);
    margin-bottom: 10px;
  }
  .info_message, .error_message {
    margin-top: 10px;
    margin-left: 10px;
  }
}
.select_list {
  display: flex;
  flex-wrap: wrap;
  line-height: 35px;
  padding: 0 10px;
  margin-bottom: 10px;
  background: #e9e9e9;
  .radio {
    label:focus, label:hover {
      color: #68C2C3;
    }
    label:focus:before, label:hover:before, label:active:before, input:checked + label:before {
      border-color: #68c2c3;
      background: #ffffff;
    }
    input[type=radio] {
      display: none;
      padding: .375rem .75rem;
      line-height: 1.5;
    }
    label {
      display: inline-block;
      font-weight: bold;
      position: relative;
      overflow: hidden;
      padding-left: 27px;
      cursor: pointer;
      -webkit-transition: all 0.15s ease;
      transition: all 0.15s ease;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    label:before {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 8px;
      height: 8px;
      content: '';
      border: 0.2em solid #cccccc;
      background: #fff;
    }
    input:checked + label:before {
      border-color: #68c2c3;
      background: #68c2c3;
    }
  }
}
#new-trial-user, #new-dc-user {
  padding-top: 30px;
  text-align: center;
  .input_area{
    border-radius: 5px;
    background-color: #fff;
    margin-right: 50px;
    .mail{
      background: #fafafa;
      &:focus {
        outline: none;
      }
    }
    input[type="text"] ,input[type="tel"] ,input[type="password"] {
      width: 200px;
    }
    input[type="checkbox"] {
      width: 220px;
    }
    select {
      width: 228px;
    }
    .error_message {
      margin: 10px 0;
    }
  }
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 200px;
    font-weight: normal;
  }
  .validate_error_messages {
    color: #dc3545;
    margin: 5px 5px 5px 205px;
    text-align: left;
  }
  .valid_description {
    font-size: 11.3px;
    width: 227px;
    margin-left: 205px;
    text-align: left;
    margin-top: 2px;
  }
  i {
    margin: 0 3px 0 5px;
    color: #ff4500;
    transform: translateY(5px);
  }
}
#trial-main-url-modal {
  font-size: 15px;
  font-weight: normal;
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 120px;
    font-weight: normal;
  }
}
.trial-main-url-modal{
  max-width: 525px;
}
#new-ftp-modal {
  padding-top: 30px;
  margin-left: 0;
  padding-left: inherit;
  .input_area {
    border-radius: 5px;
    background-color: #fff;
    margin-right: 100px;
    margin-left: 0;
    padding-left: 0;
    .mail{
      background: #fafafa;
      &:focus {
        outline: none;
      }
    }
    input[type="text"] ,input[type="tel"] ,input[type="password"] {
      width: 200px;
    }
    input[type="checkbox"] {
      width: 220px;
    }
    select {
      width: 228px;
    }
    .error_message {
      margin: 10px 0;
    }
  }
  span.label {
    text-align: right;
    display: inline-block;
    min-width: 200px;
    font-weight: normal;
  }
  .validate_error_messages {
    color: #dc3545;
    margin: 5px 5px 5px 50px;
    text-align: left;
  }
  .valid_description {
    font-size: 11.3px;
    width: 227px;
    margin-left: 50px;
    text-align: left;
    margin-top: 2px;
  }
  i {
    margin: 0 3px 0 5px;
    color: #ff4500;
    transform: translateY(5px);
  }
  .label {
    margin-right: 10px;
  }
  .headline {
    text-align: center;
    font-size: 13px;
  }
  .kobetu {
    text-align: center;
    font-weight: normal;
  }
  .validate_error_messages {
    padding-left: 170px;
  }
  .error_message {
    padding-left: 190px;
  }
}
.modal-ftp {
  background-color: white;
  width: 60%;
  max-width: 500px;
  height: auto;
  max-height: 60%;
  padding: 10px;
  overflow: auto;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  .title-area {
    padding: 10px;
  }
  .message-area {
    padding: 20px 50px;
    word-wrap: break-word;
  }
  .input-area {
    text-align: left;
    padding: 10px 10px 10px 10px;
    line-height: 30px;
    li {
      margin-top: 5px;
      margin-bottom: 15px;
    }
    .button-area {
      border-top: 1px solid #ddd;
      padding: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/tab/Debug.vue